import { render, staticRenderFns } from "./FormSubmissionsList.vue?vue&type=template&id=4a3628ee&"
import script from "./FormSubmissionsList.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports